// 숫자를 쉼표가 포함된 형태로 포맷팅하는 함수
export const formatNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

// 만원 단위로 포맷팅하는 함수 
export const formatManWon = (num) => {
  if (num === null || num === undefined || isNaN(num)) {
    return '0';
  }
  return formatNumber(num);
};